/**
 * sessionStorageへの保存が許可されているフォーム
 *
 * セキュリティ上の理由により、以下は除外:
 * - form4: クレジットカード情報（PCI DSS準拠のため）
 */
export const ALLOWED_FORMS_FOR_SESSION_STORAGE = [
  'form1',
  'form2',
  'form3',
  'form5',
] as const;

export type AllowedFormName = typeof ALLOWED_FORMS_FOR_SESSION_STORAGE[number];
